import { render, staticRenderFns } from "./LayoutContent.vue?vue&type=template&id=56f2385e&scoped=true&"
import script from "./LayoutContent.vue?vue&type=script&lang=js&"
export * from "./LayoutContent.vue?vue&type=script&lang=js&"
import style0 from "./LayoutContent.vue?vue&type=style&index=0&id=56f2385e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f2385e",
  null
  
)

export default component.exports